import { DialogContent, Grid, DialogTitle, DialogActions } from '@mui/material';
import { FC } from 'react';
import { WsDialog, Label, WsButton } from 'wisestep-base';
export interface DeleteConfirmationDialogProps {
  openDialog: boolean;
  closeDialog(): void;
  handler: (isEdit: boolean) => void;
  isEdit: boolean;
  onArchive: (archive: boolean) => void;
}

const DeleteConfirmationDialog: FC<DeleteConfirmationDialogProps> = ({
  openDialog,
  closeDialog,
  handler,
  isEdit = false,
  onArchive,
}) => (
  <WsDialog openDialog={openDialog} size="medium">
    <DialogTitle>
      <Grid container spacing={1} direction="column">
        <Grid item xs={12}>
          {isEdit ? (
            <Label sx={{ fontWeight: 'bold' }}>Are you sure you want to edit the status ?</Label>
          ) : (
            <Label sx={{ fontWeight: 'bold' }}>Are you sure you want to delete the Status ?</Label>
          )}
        </Grid>
      </Grid>
    </DialogTitle>
    <DialogContent>
      <Grid container spacing={1} direction="column" display="flex" textAlign="center">
        <Grid item xs={12}>
          {isEdit ? (
            <>
              <Label>
                When you edit a Status, the changes will apply to all instances of this status
                throughout the system . Please proceed with caution ,as any modifications made will
                affect all associated data and process
              </Label>
              <Label>
                if you wish to preserve the current status, consider archiving it and creating a new
                one
              </Label>
            </>
          ) : (
            <>
              <Label>
                When you delete a status the change is permanent . However, if you archive it, you
                can still use it as part of your filters . Please note that candidates already
                submitted with this status will not be affected
              </Label>
            </>
          )}
        </Grid>
      </Grid>
    </DialogContent>
    <DialogActions
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        paddingX: 5,
        marginX: 4,
        paddingY: 2,
      }}
    >
      <WsButton onClick={() => closeDialog()} variant="outlined">
        Go Back
      </WsButton>
      <WsButton onClick={() => onArchive(true)}>Archive</WsButton>
      <WsButton onClick={() => handler(isEdit)}>{`${isEdit ? 'Confirm Edit' : 'Delete'}`}</WsButton>
    </DialogActions>
  </WsDialog>
);

export default DeleteConfirmationDialog;
